module.exports = __webpack_public_path__ + "img/icon_right_arrow.d28cb935.svg";